import React, { FC } from "react";

import { ModelsListingModel } from "./models/ModelsListing.model";
import { TModelsListingProps } from "./types/ModelsListing.types";
import ModelsListItem from "./components/ModelsListingItem";
import { appendToUrlPath } from "../../utils";

import "./style.scss";

const ModelsListing: FC<TModelsListingProps> = (props) => {
  const model = new ModelsListingModel(props);
  const modelsItems = model.modelsListData?.items || [];

  return (
    <div>
      <section className="models-listing">
        <div className="models-listing__container">
          <div className="models-listing__list">
            {modelsItems.map((modelsItem, i) => (
              <ModelsListItem
                url={appendToUrlPath(model.url, modelsItem.titleUrl)}
                item={modelsItem}
                key={`models-item-${i}`}
              />
            ))}
          </div>
        </div>
      </section>
    </div>
  );
};

export default ModelsListing;
